// extracted by mini-css-extract-plugin
module.exports = {"questionWrapper":"FaqPart_questionWrapper__3lOIb","answer":"FaqPart_answer__7eF_W"};